import { render } from "./HealthBadge.vue?vue&type=template&id=63cebfb1"
import script from "./HealthBadge.vue?vue&type=script&lang=js"
export * from "./HealthBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__